import { DatePipe, NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DateHelper } from 'src/app/helpers/date-helper';
import { TchatMessage } from '../../../models/server/tchat-message';
import { TchatUser } from '../../../models/server/tchat-user';
import { TchatUserIdentityComponent } from '../tchat-user-identity/tchat-user-identity.component';

@Component({
    selector: 'app-tchat-room-message',
    templateUrl: './tchat-room-message.component.html',
    styleUrls: ['./tchat-room-message.component.scss'],
    imports: [TchatUserIdentityComponent, NgClass, DatePipe]
})
export class TchatRoomMessageComponent {
    /**
     * Références des constantes utilisées dans le template.
     */
    public FRENCH_DATETIME_FORMAT = DateHelper.FRENCH_DATETIME_FORMAT;
    public FRENCH_DATE_FORMAT = DateHelper.FRENCH_DATE_FORMAT;
    public FRENCH_DATETIME_WITHOUT_SECONDS_FORMAT = DateHelper.FRENCH_DATETIME_WITHOUT_SECONDS_FORMAT;

    /**
     * Valeur indiquant si il s'agit d'un tchat en live (true) ou de l'historique d'un tchat (false).
     */
    @Input()
    public isLiveTchat: boolean;

    /**
     * Utilisateur à l'origine de la conversation.
     */
    @Input()
    public sourceUser: TchatUser;

    /**
     * Utilisateur à l'origine du precedent message.
     */
    @Input()
    public previousMessageUser: TchatUser;

    /**
     * Message de la conversation.
     */
    @Input()
    public message: TchatMessage;

    /**
     * Date du jour.
     * Utilisé pour déterminer le format d'affichage des dates.
     */
    public currentDate: Date = new Date();

    /**
     * Constructeur.
     */
    constructor() {}
}
